// MDS Free Trial Week promo: a React component with no dependencies beyond React.
// Fonts: Satoshi (api.fontshare.com) and Inter (Google Fonts). Load these in your app.
import { useEffect, useState, type CSSProperties } from 'react';

type Day = [short: string, long: string, date: number];

const DAYS: Day[] = [
  ['Mon', 'Monday', 19],
  ['Tue', 'Tuesday', 20],
  ['Wed', 'Wednesday', 21],
  ['Thu', 'Thursday', 22],
  ['Fri', 'Friday', 23],
  ['Sat', 'Saturday', 24],
  ['Sun', 'Sunday', 25],
];
const FLIP_MS = 1900;

const CSS = `
.mds-ft{max-width:1240px;margin:0 auto;padding:clamp(56px,7vw,96px) clamp(10px,3.5vw,54px) 0;font-family:Satoshi,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased}
.mds-ft *{box-sizing:border-box}
.mds-ft-card{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,420px),1fr));border-radius:26px;overflow:hidden;background:#0b1014;color:#fff;box-shadow:0 30px 70px -36px rgba(11,15,21,.45)}
.mds-ft-cta{display:flex;align-items:center;gap:10px;min-height:54px;padding:0 30px;border-radius:999px;background:#5bfcc3;color:#0b0f15;font-size:16px;font-weight:700;letter-spacing:-.01em;text-decoration:none;transition:transform 220ms cubic-bezier(.2,.7,.2,1),background 220ms ease,box-shadow 220ms ease}
.mds-ft-cta:hover{transform:translateY(-3px);background:#fff;color:#0b0f15;box-shadow:0 18px 40px rgba(91,252,195,.28)}

.mfc{position:absolute;inset:-1px;overflow:hidden;background:#0b1014;container-type:size;font-family:Satoshi,Helvetica,Arial,sans-serif;color:#fff}
.mfc-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,.045) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.045) 1px,transparent 1px);background-size:34px 34px;mask-image:radial-gradient(circle at 50% 48%,#000 20%,transparent 75%);-webkit-mask-image:radial-gradient(circle at 50% 48%,#000 20%,transparent 75%)}
.mfc-glow{position:absolute;left:53%;top:46%;width:80cqmin;height:80cqmin;transform:translate(-50%,-50%);border-radius:50%;background:radial-gradient(circle,rgba(91,252,195,.22),rgba(91,252,195,0) 62%);animation:mfc-pulse 3.4s ease-in-out infinite}
@keyframes mfc-pulse{50%{opacity:.6;transform:translate(-50%,-50%) scale(.92)}}
.mfc-fx,.mfc-stage{position:absolute;inset:0 -6% 0 6%;--w:min(42cqh,52cqw,250px);--h:calc(var(--w)*.72)}
@media (max-width:1023.98px){.mfc-fx,.mfc-stage{inset:0}.mfc-glow{left:50%}}
.mfc-fx{pointer-events:none}
.mfc-stage{display:flex;align-items:center;justify-content:center;perspective:calc(var(--w)*4.2)}
.mfc-ring{position:absolute;left:50%;top:50%;border-radius:50%;transform:translate(-50%,-50%)}
.mfc-r1{width:calc(var(--w)*2);height:calc(var(--w)*2);border:1.5px dashed rgba(91,252,195,.35);animation:mfc-spin 40s linear infinite}
.mfc-r2{width:calc(var(--w)*2.6);height:calc(var(--w)*2.6);border:1px solid rgba(255,255,255,.07)}
.mfc-r1::before,.mfc-r1::after{content:"";position:absolute;width:10px;height:10px;border-radius:50%;background:#5bfcc3;box-shadow:0 0 14px #5bfcc3;top:-5px;left:50%;margin-left:-5px}
.mfc-r1::after{top:auto;bottom:-5px;width:7px;height:7px;background:#fff;box-shadow:0 0 10px rgba(255,255,255,.7)}
@keyframes mfc-spin{to{transform:translate(-50%,-50%) rotate(360deg)}}
.mfc-spark{position:absolute;width:14px;height:14px;animation:mfc-tw 2.6s ease-in-out infinite}
.mfc-spark::before,.mfc-spark::after{content:"";position:absolute;left:50%;top:0;width:2px;height:100%;margin-left:-1px;border-radius:2px;background:currentColor}
.mfc-spark::after{transform:rotate(90deg)}
@keyframes mfc-tw{0%,100%{opacity:.25;transform:scale(.6) rotate(0)}50%{opacity:1;transform:scale(1) rotate(45deg)}}
.mfc-dot{position:absolute;bottom:-12px;border-radius:3px;background:#5bfcc3;opacity:0;animation:mfc-rise linear infinite}
@keyframes mfc-rise{10%{opacity:.7}80%{opacity:.5}to{opacity:0;transform:translateY(-110cqh) rotate(220deg)}}
.mfc-scene{position:relative;transform-style:preserve-3d;animation:mfc-bob 3.4s ease-in-out infinite}
@keyframes mfc-bob{50%{transform:translateY(calc(var(--w)*-.04))}}
.mfc-floor{position:absolute;left:10%;right:10%;bottom:calc(var(--w)*-.2);height:calc(var(--w)*.14);border-radius:50%;background:radial-gradient(closest-side,rgba(0,0,0,.65),transparent);filter:blur(6px);transform:translateZ(calc(var(--w)*-.3))}
.mfc-sheet{position:absolute;inset:0;border-radius:calc(var(--w)*.075)}
.mfc-sa{transform:translate3d(0,calc(var(--w)*.03),calc(var(--w)*-.025)) scaleX(.97);background:#dfe4e9}
.mfc-sb{transform:translate3d(0,calc(var(--w)*.06),calc(var(--w)*-.05)) scaleX(.94);background:#c3cbd3}
.mfc-sc{transform:translate3d(0,calc(var(--w)*.09),calc(var(--w)*-.075)) scaleX(.91);background:#5bfcc3;box-shadow:0 0 calc(var(--w)*.25) rgba(91,252,195,.35)}
.mfc-card{position:relative;width:var(--w);border-radius:calc(var(--w)*.075);background:#f8fafc;color:#0b0f15;box-shadow:0 30px 60px -20px rgba(0,0,0,.6),0 0 0 1px rgba(255,255,255,.06);transform-style:preserve-3d}
.mfc-pop{animation:mfc-pop .7s cubic-bezier(.2,.7,.2,1)}
@keyframes mfc-pop{30%{transform:translateZ(calc(var(--w)*.09))}}
.mfc-sheen{position:absolute;inset:0;border-radius:inherit;pointer-events:none;background:linear-gradient(115deg,rgba(255,255,255,0) 30%,rgba(255,255,255,.55) 45%,rgba(255,255,255,0) 60%);background-size:250% 100%;mix-blend-mode:soft-light;animation:mfc-sheen 7s ease-in-out infinite;z-index:6}
@keyframes mfc-sheen{0%,100%{background-position:100% 0}50%{background-position:0 0}}
.mfc-rings{position:absolute;left:0;right:0;top:calc(var(--w)*-.05);display:flex;justify-content:center;gap:calc(var(--w)*.34);z-index:7}
.mfc-rings i{width:calc(var(--w)*.05);height:calc(var(--w)*.13);border-radius:99px;background:#0b0f15;box-shadow:0 0 0 calc(var(--w)*.014) #2a3138}
.mfc-head{display:flex;justify-content:space-between;align-items:center;padding:calc(var(--w)*.075) calc(var(--w)*.08) calc(var(--w)*.06);background:#5bfcc3;border-radius:calc(var(--w)*.075) calc(var(--w)*.075) 0 0;font-size:calc(var(--w)*.062);font-weight:700;letter-spacing:.14em;text-transform:uppercase}
.mfc-digits{position:relative;height:var(--h);margin:calc(var(--w)*.07) calc(var(--w)*.07) 0;perspective:calc(var(--w)*3)}
.mfc-half{position:absolute;left:0;right:0;height:50%;overflow:hidden;background:#eceff3;backface-visibility:hidden}
.mfc-half span{position:absolute;left:0;right:0;height:var(--h);line-height:var(--h);text-align:center;font-size:calc(var(--h)*.82);font-weight:900;letter-spacing:-.05em}
.mfc-top{top:0;border-radius:calc(var(--w)*.05) calc(var(--w)*.05) 0 0;transform-origin:50% 100%}
.mfc-top span{top:0}
.mfc-bot{bottom:0;border-radius:0 0 calc(var(--w)*.05) calc(var(--w)*.05);transform-origin:50% 0}
.mfc-bot span{bottom:0}
.mfc-shade{position:absolute;inset:0;pointer-events:none;opacity:0;z-index:2}
.mfc-top .mfc-shade{background:linear-gradient(rgba(11,15,21,0),rgba(11,15,21,.3))}
.mfc-bot .mfc-shade{background:linear-gradient(rgba(11,15,21,.35),rgba(11,15,21,0))}
.mfc-flipping .mfc-shade{animation:mfc-sh .64s ease-in-out}
@keyframes mfc-sh{50%{opacity:1}}
.mfc-fbot,.mfc-ftop{z-index:3;box-shadow:0 0 calc(var(--w)*.06) rgba(0,0,0,.18)}
.mfc-ftop{animation:mfc-ft .32s cubic-bezier(.55,0,.85,.4) forwards}
.mfc-fbot{transform:rotateX(90deg);animation:mfc-fb .32s .32s cubic-bezier(.15,.6,.45,1) forwards}
@keyframes mfc-ft{to{transform:rotateX(-90deg);filter:brightness(.8)}}
@keyframes mfc-fb{from{transform:rotateX(90deg);filter:brightness(.85)}to{transform:rotateX(0)}}
.mfc-foot{display:flex;justify-content:center;padding:calc(var(--w)*.06) calc(var(--w)*.08) calc(var(--w)*.075)}
.mfc-wd{font-size:calc(var(--w)*.085);font-weight:700;letter-spacing:-.02em;transition:opacity .2s,transform .2s}
.mfc-wd.out{opacity:0;transform:translateY(4px)}
.mfc-stamp{position:absolute;right:calc(var(--w)*-.13);top:calc(var(--w)*.2);width:calc(var(--w)*.34);height:calc(var(--w)*.34);border-radius:50%;display:grid;place-items:center;background:#0b1014;color:#5bfcc3;border:2px solid #5bfcc3;font-size:calc(var(--w)*.075);font-weight:900;letter-spacing:.04em;transform:rotate(14deg) translateZ(calc(var(--w)*.08));box-shadow:0 10px 24px rgba(0,0,0,.4);z-index:7}
@media (prefers-reduced-motion:reduce){.mfc-r1,.mfc-spark,.mfc-dot,.mfc-glow,.mfc-scene,.mfc-sheen,.mfc-pop,.mfc-fbot,.mfc-ftop,.mfc-shade{animation:none}.mfc-fbot{transform:none}}
`;

// [left %, size px, duration s, delay s]
const DOTS: [number, number, number, number][] = [
  [18, 6, 9, 0],
  [32, 4, 12, 3],
  [58, 7, 10, 1.5],
  [70, 5, 14, 5],
  [86, 6, 11, 7],
  [44, 4, 13, 8.5],
];
// [left %, top %, colour, delay s]
const SPARKS: [number, number, string, number][] = [
  [14, 22, '#5bfcc3', 0],
  [84, 64, '#fff', 0.8],
  [22, 70, '#fff', 1.5],
  [74, 20, '#5bfcc3', 2],
  [90, 40, '#5bfcc3', 0.4],
  [10, 48, '#5bfcc3', 1.1],
];

export type FlipCalendarProps = {
  month?: string;
  year?: number;
};

export function FlipCalendar({ month = 'October', year = 2026 }: FlipCalendarProps) {
  const [i, setI] = useState(0);
  const [prev, setPrev] = useState(0);
  const [flip, setFlip] = useState(0); // increments per flip; 0 = idle at mount
  const [flipping, setFlipping] = useState(false);
  const [wd, setWd] = useState(0);
  const [wdOut, setWdOut] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const timers: ReturnType<typeof setTimeout>[] = [];
    const id = setInterval(() => {
      setI((cur) => {
        const n = (cur + 1) % DAYS.length;
        setPrev(cur);
        setFlip((f) => f + 1);
        setFlipping(true);
        setWdOut(true);
        timers.push(
          setTimeout(() => {
            setWd(n);
            setWdOut(false);
          }, 300),
        );
        timers.push(setTimeout(() => setFlipping(false), 680));
        return n;
      });
    }, FLIP_MS);
    return () => {
      clearInterval(id);
      timers.forEach(clearTimeout);
    };
  }, []);

  const n = DAYS[i][2];
  const p = DAYS[prev][2];
  return (
    <div className="mfc" role="img" aria-label="Calendar flipping through 19 to 25 October">
      <style>{CSS}</style>
      <div className="mfc-grid" />
      <div className="mfc-glow" />
      <div className="mfc-fx">
        <div className="mfc-ring mfc-r2" />
        <div className="mfc-ring mfc-r1" />
        {DOTS.map(([x, s, d, del], k) => (
          <i
            key={'d' + k}
            className="mfc-dot"
            style={{ left: x + '%', width: s, height: s, animationDuration: d + 's', animationDelay: del + 's' }}
          />
        ))}
        {SPARKS.map(([x, y, c, del], k) => (
          <i
            key={'s' + k}
            className="mfc-spark"
            style={{ left: x + '%', top: y + '%', color: c, animationDelay: del + 's' }}
          />
        ))}
      </div>
      <div className="mfc-stage">
        <div className="mfc-scene">
          <div className="mfc-floor" />
          <div className="mfc-sheet mfc-sc" />
          <div className="mfc-sheet mfc-sb" />
          <div className="mfc-sheet mfc-sa" />
          <div key={'c' + flip} className={'mfc-card' + (flip ? ' mfc-pop' : '')}>
            <div className="mfc-rings">
              <i />
              <i />
            </div>
            <div className="mfc-head">
              <span>{month}</span>
              <span>{year}</span>
            </div>
            <div key={'g' + flip} className={'mfc-digits' + (flipping ? ' mfc-flipping' : '')}>
              <div className="mfc-half mfc-top">
                <span>{n}</span>
                <b className="mfc-shade" />
              </div>
              <div className="mfc-half mfc-bot">
                <span>{flipping ? p : n}</span>
                <b className="mfc-shade" />
              </div>
              {/* The old number's top half falls over the hinge, then the new
                  number's bottom half lands on the old one. */}
              {flipping && (
                <div className="mfc-half mfc-top mfc-ftop">
                  <span>{p}</span>
                </div>
              )}
              {flipping && (
                <div className="mfc-half mfc-bot mfc-fbot">
                  <span>{n}</span>
                </div>
              )}
            </div>
            <div className="mfc-foot">
              <span className={'mfc-wd' + (wdOut ? ' out' : '')}>{DAYS[wd][1]}</span>
            </div>
            <div className="mfc-stamp">FREE</div>
            <div className="mfc-sheen" />
          </div>
        </div>
      </div>
    </div>
  );
}

const dayTile: CSSProperties = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 2,
  padding: '10px 0',
  borderRadius: 12,
  background: 'rgba(255,255,255,0.07)',
};
const edgeTile: CSSProperties = {
  ...dayTile,
  background: 'rgba(91,252,195,0.1)',
  boxShadow: 'inset 0 0 0 1px rgba(91,252,195,0.45)',
};
const edgeLabel: CSSProperties = {
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: '100%',
  marginBottom: 6,
  textAlign: 'center',
  fontFamily: 'Inter,sans-serif',
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color: '#5bfcc3',
};

export type FreeTrialPromoProps = {
  href?: string;
  title?: string;
  description?: string;
  hours?: string;
  note?: string;
  ctaLabel?: string;
};

export default function FreeTrialPromo({
  href = '/book/free-trial-week',
  title = 'MDS Free Trial Week',
  description = 'Our doors are open and the first week is on us. From 19 to 24 October, pull up a desk, meet the people building alongside you, and see how Minyeh works.',
  hours = '8:00 AM – 6:00 PM',
  note = 'Shared desks only',
  ctaLabel = 'Book Your Free Desk',
}: FreeTrialPromoProps) {
  return (
    <section id="free-trial" className="mds-ft">
      <div className="mds-ft-card">
        <div style={{ position: 'relative', minHeight: 340 }}>
          <FlipCalendar />
        </div>
        <div style={{ padding: 'clamp(28px,4vw,52px)', display: 'flex', flexDirection: 'column', gap: 26 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <span
              style={{
                alignSelf: 'flex-start',
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                color: '#5bfcc3',
                fontFamily: 'Inter,sans-serif',
                fontSize: 11.5,
                fontWeight: 600,
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
              }}
            >
              <span style={{ width: 28, height: 1.5, background: '#5bfcc3' }} />
              Opening week
            </span>
            <h2
              style={{
                margin: 0,
                fontSize: 'clamp(26px,3.3vw,44px)',
                fontWeight: 700,
                lineHeight: 1.04,
                letterSpacing: '-0.035em',
                whiteSpace: 'nowrap',
              }}
            >
              {title}
            </h2>
            <p
              style={{
                margin: 0,
                maxWidth: '44ch',
                fontFamily: 'Inter,sans-serif',
                fontSize: 15,
                lineHeight: 1.55,
                color: 'rgba(255,255,255,0.78)',
                textWrap: 'pretty',
              }}
            >
              {description}
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,minmax(0,1fr))', gap: 6, paddingTop: 20 }}>
            {DAYS.map(([short, , d], k) => {
              const edge = k === 0 ? 'Start' : k === DAYS.length - 1 ? 'End' : null;
              return (
                <div key={d} style={edge ? edgeTile : dayTile}>
                  {edge && <span style={edgeLabel}>{edge}</span>}
                  <small
                    style={{
                      fontFamily: 'Inter,sans-serif',
                      fontSize: 10.5,
                      letterSpacing: '0.06em',
                      textTransform: 'uppercase',
                      color: 'rgba(255,255,255,0.6)',
                    }}
                  >
                    {short}
                  </small>
                  <b style={{ fontSize: 19 }}>{d}</b>
                </div>
              );
            })}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '14px 22px' }}>
            {[hours, note].map((t) => (
              <b key={t} style={{ fontSize: 15, color: '#fff' }}>
                {t}
              </b>
            ))}
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px 18px', alignItems: 'center', marginTop: 'auto' }}>
            <a className="mds-ft-cta" href={href}>
              {ctaLabel} <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
